/**
 * Created by jonas on 2020-03-18.
 */
import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";

import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {TheCageGameAssets} from "../TheCageGameAssets";
import {TheCage} from "../TheCage";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";

export class TheCageIntroConfig implements GameIntroViewConfig {

    colors:GameIntroColors = {
        slideShowColors : {
            backgroundColor : 0x000000, //Default 0x000000
            backgroundAlpha : 0.4, //Default 0.4
            bulletColor : 0xffffff, //Default 0xffffff

        },
        stampColor : 0xFFFFFF
    };

    stampConfig:StampConfig = {
        xBomb : true,
        volatility : Volatility.HIGH
    };

    background:PIXI.Container;
    borderBottom:PIXI.Container;
    borderTop:PIXI.Container;
    logo:PIXI.Container;
    pages:SlideShowPage[];

    private betBoostAllowed:boolean = false;

    constructor() {
    }

    public init():Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add(TheCageGameAssets.MAIN_GAME_BACKGROUND, TheCageGameAssets.MAIN_GAME_BACKGROUND);
        imgLoader.add("introDiv", "resources/images/Intro_Divider.png");
        imgLoader.add("feature1", "resources/images/intro_feature1.png");
        imgLoader.add("feature2", "resources/images/intro_feature2.png");
        imgLoader.add("betBoost", "resources/images/betBoost.png");
        imgLoader.add(TheCageGameAssets.IMAGES_LOGO, TheCageGameAssets.IMAGES_LOGO);

        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    onShow() {
        this.logo.parent.addChild(this.logo);
    }
    onResize() {
        this.logo.y += 20;
    }

    private initGraphics() {
        return new Promise((resolve, reject) => {

            this.background = new PIXI.Container();
            const bgSprite = new PIXI.Sprite(TheCageGameAssets.MAIN_GAME_BACKGROUND_TEXTURE);
            bgSprite.anchor.set(0.5, 0.5);
            this.background.addChild(bgSprite);

            this.borderTop = new PIXI.Container();
            const topSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
            topSprite.anchor.set(0.5, 0.5);
            this.borderTop.addChild(topSprite);

            this.borderBottom = new PIXI.Container();
            const bottomSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
            bottomSprite.rotation = Math.PI;
            bottomSprite.anchor.set(0.5, 0.5);
            this.borderBottom.addChild(bottomSprite);

            this.logo = new PIXI.Container();
            const logoSprite = new PIXI.Sprite(TheCageGameAssets.IMAGES_LOGO_TEXTURE);
            logoSprite.anchor.set(0.5, 0.5);
            logoSprite.position.set(0, -15);
            logoSprite.scale.set(0.8, 0.8);
            this.logo.addChild(logoSprite);


            const featureSprite1 = new PIXI.Sprite(ImgLoader.getImgTexture("feature1"));
            featureSprite1.anchor.set(0.5, 0.5);

            const featureSprite2 = new PIXI.Sprite(ImgLoader.getImgTexture("feature2"));
            featureSprite2.anchor.set(0.5, 0.5);


            this.pages = [
                new SlideShowPage(),
                new SlideShowPage(),
            ];


            this.pages[0].addChild(featureSprite1);
            this.pages[1].addChild(featureSprite2);


            this.betBoostAllowed = TheCage.apiPlugin.gameClientConfiguration.boostedBetAllowed;

            if(TheCage.apiPlugin.gameClientConfiguration.isSet) {
                if(TheCage.apiPlugin.gameClientConfiguration.boostedBetAllowed) {
                    this.addBoostPage();
                }
                resolve(this);
            }
            else {
                TheCage.apiPlugin.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                    if(TheCage.apiPlugin.gameClientConfiguration.boostedBetAllowed) {
                        this.addBoostPage();
                    }
                    resolve(this);
                });
            }

        });

    }

    private addBoostPage() {
        const betBoostImage = new PIXI.Sprite(ImgLoader.getImgTexture("betBoost"));
        betBoostImage.anchor.set(0.5, 0.5);
        const page = new SlideShowPage();
        page.addChild(betBoostImage)
        this.pages.splice(0, 0, page);
    }
}